var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBored1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM6.5 7.25C6.08579 7.25 5.75 7.58579 5.75 8C5.75 9.51878 6.98122 10.75 8.5 10.75C10.0188 10.75 11.25 9.51878 11.25 8C11.25 7.58579 10.9142 7.25 10.5 7.25C10.0858 7.25 9.75 7.58579 9.75 8C9.75 8.69036 9.19036 9.25 8.5 9.25C7.80964 9.25 7.25 8.69036 7.25 8C7.25 7.58579 6.91421 7.25 6.5 7.25ZM13.5 7.25C13.0858 7.25 12.75 7.58579 12.75 8C12.75 9.51878 13.9812 10.75 15.5 10.75C17.0188 10.75 18.25 9.51878 18.25 8C18.25 7.58579 17.9142 7.25 17.5 7.25C17.0858 7.25 16.75 7.58579 16.75 8C16.75 8.69036 16.1904 9.25 15.5 9.25C14.8096 9.25 14.25 8.69036 14.25 8C14.25 7.58579 13.9142 7.25 13.5 7.25ZM12 19C13.6569 19 15 17.6569 15 16C15 14.3431 13.6569 13 12 13C10.3431 13 9 14.3431 9 16C9 17.6569 10.3431 19 12 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBored1);
export default __webpack_public_path__ + "static/media/bored-1.f372b4e0f3f9b2ae0f2bca507834c80e.svg";
export { ForwardRef as ReactComponent };